import { Injectable } from '@angular/core';
import { UrlSegment } from '@angular/router';
import { BehaviorSubject, Observable, throwError} from 'rxjs';
import { BreadcrumbsDTO } from '@signature-it/ngx-generic/models';
import { IBreadcrumbs } from '@signature-it/ngx-generic/interfaces';
import { HttpClient } from "@angular/common/http";
import {RestUrlsConfig} from '@signature-it/ngx-generic/config';
declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbsService {

    breadcrumbs$ = new BehaviorSubject(null);
    unsubscribeToUrl$ = new BehaviorSubject(null);
    public queryParamFilter: any = {};
    private _classAttr = '';
    protected getEntityBreadcrumbsUrl = `${this.config.appURL}/public/entity/breadcrumbs`;

    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig
    ) {}

    init(): IBreadcrumbs[] {
        const list = [{name: '', link: '/'}];
        return BreadcrumbsDTO.createFromArray(list);
    }

    set(url: UrlSegment): void {
        let routerList = this.init();

        if(!(url instanceof UrlSegment)) return;

        this.breadcrumbs$.next({
            list: _.assign(routerList, this.parse(url)),
            concat: true
        });
    }

    setByArray(urls: Array<string>): void {
        let result = "";
        for (let url of urls) {
          if(url !== "1" && url !== "Object" && url !== "Home") {
            result += "/"+url;
          }
        }
        this.set(new UrlSegment(result, null));
    }

    setByCustomArray(list: Array<IBreadcrumbs>): void {
        if (list && list[0].name === '1') list[0].name = '';
        this.breadcrumbs$.next({
            list: BreadcrumbsDTO.createFromArray(list),
            concat: false
        });
    }

    set classAttr(value) {
        this._classAttr = value;
    }

    get classAttr() {
        return this._classAttr;
    }

    parse(url: UrlSegment): IBreadcrumbs[] {
        const path = url.path.replace(/^\/|\?.*/gi, '');
        const list = path.split('/') || [];
        return _.map(list, (link) => {
            if(link) {
                return BreadcrumbsDTO.create({
                    name: _.startCase(link).replace(/-/gi, ' '),
                    link: link
                });
            }
        });
    }

    getEntityBreadcrumbs(params): Observable<any> {
        return this.http.get(`${this.getEntityBreadcrumbsUrl}`, {
            params: { ...params }
        });
    }

}
